/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MatchCompetency } from '../../models/match-competency';

export interface CreateMatchCompetency$Params {
      body?: MatchCompetency
}

export function createMatchCompetency(http: HttpClient, rootUrl: string, params?: CreateMatchCompetency$Params, context?: HttpContext): Observable<StrictHttpResponse<MatchCompetency>> {
  const rb = new RequestBuilder(rootUrl, createMatchCompetency.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MatchCompetency>;
    })
  );
}

createMatchCompetency.PATH = '/matchcompetency';
